<div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1060">
  <div #toastElement class="toast align-items-center text-white bg-{{type}} border-0" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        {{ message }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Cerrar"></button>
    </div>
  </div>
</div>